import React, {
  useState,
  useEffect,
  useContext,
  useCallback,
  useRef,
} from "react";
import { useDebounce } from "use-debounce";
import { v4 as uuidv4 } from "uuid";
import pdfDetails from "../../api/pdfDetails";
import { AuthContext } from "../../context/Auth/AuthContext";
import Loading from "../material-ui/Loading";
import PdfDetails from "./PdfDetails";
import PdfVersion from "./PdfVersion";
import PdfEditor from "./PdfEditor";
import pdfBase64Data from "../../api/pdfBase64Data";
import getDocumentRequestStatus from "../../api/getDocumentRequestStatus";
import { IoArrowBackCircleSharp } from "react-icons/io5";
import { IoDocumentText } from "react-icons/io5";
import { IoCheckmarkCircle, IoTimeOutline } from "react-icons/io5";
import ApprovePDFDocumentPopup from "../client-table/client-documents/ApprovePDFDocumentPopup";
import RejectPDFDocumentPopup from "../client-table/client-documents/RejectPDFDocumentPopup";
// Add Task feature disabled (SugarCRM-dependent) - see below for re-enable notes
// import AddTask from "../document-table/AddTask";
import { useDrop } from "react-dnd";
import ChatPopup from "../common/ocr/OcrPopup";
import OcrProcessingDialog from "../common/ocr/OcrProcessingDialog";
import { TbVersions } from "react-icons/tb";
import { FaDownload, FaHistory } from "react-icons/fa";
import { RiCloseCircleFill } from "react-icons/ri";
import { Tooltip } from "@mui/material";
import ButtonUI from "../material-ui/ButtonUI";
import OcrScanIcon from "../common/OcrScanIcon";
import getOcrFullData from "../../api/getOcrFullData";
import ViewerActionButton from "../common/ViewerActionButton";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import LinkIcon from "@mui/icons-material/Link";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import CallSplitOutlinedIcon from "@mui/icons-material/CallSplitOutlined";
import DocumentSeparationDialog from "./DocumentSeparationDialog";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import InputUI from "../material-ui/InputUI";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import SelectBox from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
// get-client-reference-number no longer called - client reference number now comes
// from getCaseStatus (see getClientRefNumber / handleClientNameChange below).
// import getClientRefNo from "../../api/getClientRefNo";
import getClientName from "../../api/getClientName";
import { toast } from "react-toastify";
import { showSuccess, showError } from "../../utils/toast";
import editDocument from "../../api/editDocument";
import baseUrl, { sugarUrl } from "../../config/baseUrl";
import clientsData from "../../api/clients";
import editClient from "../../api/editClient";
import getAllFieldTypeList from "../../api/getAllFieldTypeList";
import LinkToRequest from "../document-table/LinkToRequest";
import useDebounceSearch from "../../hooks/useDebounceSearch";
import OcrFields from "../common/ocr/OcrFields";
import "../../styles/PdfViewer.css";
import elasticToken from "../../config/elasticToken";
// Send SMS feature disabled (SugarCRM-dependent) - see below for re-enable notes
// import SendSMS from "./SendSMS";
import { Card, CardContent } from "../../shadcn-components/ui/card";
import {
  Tabs,
  TabsList,
  TabsTrigger,
  TabsContent,
} from "../../shadcn-components/ui/tabs";
import JSZip from "jszip";
import ZipViewer from "./ZipViewer";
import { useRoleContext } from "../../context/RolesContext";
import BusinessCardInfo from "../common/BusinessCardInfo";
import ClientInfoPanel from "../common/ClientInfoPanel";
import ConfirmToast from "../common/ConfirmToast";
import DocumentTypeBadge from "../common/DocumentTypeBadge";
import { format as formatDateFns } from "date-fns";

const updateDocumentDetailsFormSchema = yup.object().shape({
  name: yup.string().required("Document Name is required field"),
  subcategory: yup
    .string()
    .nullable()
    .required("Sub Category is required field"),
});

const PdfViewer = ({
  documentType,
  clientID,
  documentID,
  documentTitle,
  documentCreatedAt,
  documentURL,
  changeActiveTab,
  document_table,
  document_version,
  documentRequestID,
  existingDocumentRequestStatus,
  documentCategory,
  documentDesc,
  currentTabId,
  closeTabById,
  setDocumentDetails,
  fromTable,
  setUpdatedFromPDF,
  linkedDocReqName,
  documentSubCategory,
  clientPhone,
  showPdfOnly = false,
  benID,
  refetchDocumentTable,
  refetchTrigger,
}) => {
  const [isBlocking, setIsBlocking] = useState(false);
  const [isPdfDetailsContainerOpen, setIsPdfDetailsContainerOpen] =
    useState(false);
  const [pdfData, setPdfData] = useState({});
  const [editor, setEditor] = useState(false);
  const [pdfBase64, setPdfBase64] = useState("");
  const [documentVersionId, setDocumentVersionId] = useState(null);
  const [pdfSrc, setPdfSrc] = useState("");
  const [documentRequestStatus, setDocumentRequestStatus] = useState(
    existingDocumentRequestStatus,
  );
  const [approveConfirmOpen, setApproveConfirmOpen] = useState(false);
  const [disapproveConfirmOpen, setDisapproveConfirmOpen] = useState(false);
  const [email, setEmail] = useState(""); // state for the email field
  const [showPopup, setShowPopup] = useState(true);
  const [clientNames, setClientNames] = useState([]);
  const [description, setDescription] = useState(documentDesc);
  const [subCategoryOption, setSubCategoryOption] = useState([]);
  const [contactId, setContactId] = useState(clientID);
  const [benefId, setBenefId] = useState(
    benID !== null && benID !== "" ? benID : clientID,
  );
  const [linkRequest, setLinkRequest] = useState(false);
  // Separate a multi-document PDF into request-linked child documents.
  const [showSeparation, setShowSeparation] = useState(false);
  const [linkRequestOpen, setLinkRequestOpen] = useState(false);
  const [requestOptions, setRequestOptions] = useState([]);
  const [requestId, setRequestId] = useState(documentRequestID);
  const [showLinkButton, setShowLinkButton] = useState(false);
  const [assignClient, setAssignClient] = useState(false);
  const [clientNameLabel, setClientNameLabel] = useState("");
  const [defaultClientNameLabel, setDefaultClientNameLabel] = useState("");
  const [selectedRequestLabel, setSelectedRequestLabel] = useState("");
  const [searchedTerm, setSearchedTerm] = useState("");
  const [searchLoading, setSearchLoading] = useState(false);
  const [offset, setOffset] = useState(0);
  const [total, setTotal] = useState(0);
  const [showMoreLoading, setShowMoreLoading] = useState(false);
  const [showFields, setShowFields] = useState(false);
  const [searchedClientId, setSearchedClientId] = useState([]);
  const [additionalDataFetched, setAdditionalDataFetched] = useState(false);
  const [additionalDataLoading, setAdditionalDataLoading] = useState(false);
  const [isClientListFetched, setIsClientListFetched] = useState(false); //to check if client list fetched
  const [confirmUnknownDialogOpen, setConfirmUnknownDialogOpen] =
    useState(false);
  const [sugarTokenIssue, setSugarTokenIssue] = useState("");
  const [pendingSelectedId, setPendingSelectedId] = useState(null);
  const [currentAlienNumber, setCurrentAlienNumber] = useState();
  const [currentPhoneNumber, setCurrentPhoneNumber] = useState();
  const [clientInputValue, setClientInputValue] = React.useState("");
  const [isDocumentRendered, setIsDocumentRendered] = useState(false);
  const [ocrTrigger, setOcrTrigger] = useState(0);

  const {
    register,
    handleSubmit,
    watch,
    control,
    setValue,
    getValues,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(updateDocumentDetailsFormSchema),
  });

  const filterOptions = createFilterOptions({
    matchFrom: "any",
    ignoreCase: true, // Ignore case sensitivity
    stringify: (option) => option.fields_name,
  });

  const [pdfTab, setPdfTab] = useState([
    {
      id: uuidv4(),
      title: <IoDocumentText />,
      content: (pdfData) => (
        <PdfDetails
          pdfData={pdfData}
          documentID={documentID}
          documentTitle={documentTitle}
          documentType={documentType}
          pdfDetailsVersionData={pdfDetailsVersionData}
          documentVersionId={documentVersionId}
          setDocumentVersionId={setDocumentVersionId}
          document_version={document_version}
        />
      ),
    },
    {
      id: uuidv4(),
      title: <TbVersions />,
      content: (documentID) => <PdfVersion documentID={documentID} />,
    },
  ]);
  const [tabValue, setTabValue] = useState(pdfTab[0].id);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [pdfDataLoading, setPdfDataLoading] = useState(true);
  const [searchClientNotFound, setSearchClientNotFound] = useState(false);
  const [performOcr, setPerformOcr] = useState(false);
  const [loadingOcr, setLoadingOcr] = useState(false);
  // OCR Processing popup (UI only). ocrPhase follows the real OCR run:
  // reading (preparing) -> extracting (request in flight, loadingOcr) ->
  // analyzing (applying results) -> done. null = not running / failed.
  const [ocrPhase, setOcrPhase] = useState(null);
  const [ocrDialogOpen, setOcrDialogOpen] = useState(false);
  const ocrCompletedRef = useRef(false);
  const ocrCloseTimerRef = useRef(null);
  const [existingOcrData, setExistingOcr] = useState(false);
  const inputRef = useRef(null);
  const [zipContent, setZipContent] = useState([]); //To set zipContent
  const [isClientUnknown, setIsClientUnknown] = useState(false); //to set Client unknown
  const iframeRef = useRef(null);

  const [businessCardInfoClientID, setBusinessCardInfoClientID] = useState("");

  // Document Details / Client Information / OCR Fields panel tabs. Controlled
  // so a successful OCR run can auto-select the OCR Fields tab and briefly
  // highlight it (requirement: don't force it back afterwards, and never
  // interrupt a tab the user manually switches to).
  const [activeDetailsTab, setActiveDetailsTab] = useState("details");
  const [ocrJustCompleted, setOcrJustCompleted] = useState(false);

  const { token, user_id, is_admin } = useContext(AuthContext);

  // Display-only: has OCR already been run on this document (PDF or image)?
  // Drives the OCR button tooltip (Perform OCR / Re-OCR) only - existingOcrData
  // (which also picks add- vs update-ocr-data on Submit) is left untouched.
  // Image OCR stores only the full-document data until the fields are
  // submitted, so on open this is read from the existing get-ocr-full-data
  // API; after a run it is set when OCR completes.
  const [ocrPerformed, setOcrPerformed] = useState(false);
  useEffect(() => {
    let active = true;
    setOcrPerformed(false);
    if (documentID) {
      getOcrFullData({ token, documentId: documentID }).then((res) => {
        if (active && res?.code === 200 && res.data) {
          setOcrPerformed(true);
          // Already OCR'd: open on the OCR Fields tab, unless the user has
          // already switched away from the default tab while this loaded.
          setActiveDetailsTab((tab) => (tab === "details" ? "ocr" : tab));
        }
      });
    }
    return () => {
      active = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [documentID]);

  const isMounted = useRef(true);

  // Marks the component as unmounted once it is unmounted.
  // This prevents the issue where a tab reopens if the form is submitted and the tab is closed immediately,
  // caused by a delayed function call that updates the state and triggers the tab to open again.
  useEffect(() => {
    return () => {
      isMounted.current = false; // Mark's unmounted when tab closes
    };
  }, []);

  //Role Based Permissions

  // Function to check if the user has a specific permission.
  // Admin users ("is_admin" === "1") automatically have access to all permissions.
  const { permissions } = useRoleContext();
  const hasPermission = (permission) => {
    if (is_admin === "1") {
      return true;
    }

    return permissions.includes(permission);
  };

  // Permission flags for various user actions, granting access based on user roles or admin status.
  // Admin users have all permissions by default.
  const canEditPdf = hasPermission("edit_pdf_documents");
  const canLinkDocument = hasPermission("link_documents");
  const canRelinkDocument = hasPermission("relink_document_request");
  const canApproveDocument = hasPermission("document_approval");
  const canEditClient = hasPermission("client_edit");
  const canMarkClientUnknown = hasPermission("mark_client_unknown");
  const canPerformOCR = hasPermission("perform_ocr");
  // Add Task / Send SMS disabled (SugarCRM-dependent) - see usages below
  // const canAddTask = hasPermission("add_task");
  // const canSendSMS = hasPermission("send_sms");

  // Handles marking a client as unknown by calling the appropriate API.
  // Displays a success toast if the operation is successful, otherwise shows an error message.
  // Errors during the process are logged to the console.

  const openClientUnknownDialog = () => {
    setConfirmUnknownDialogOpen(true);
  };

  const confirmMarkClientUnknown = async () => {
    setConfirmUnknownDialogOpen(false);
  };

  // ConfirmToast calls setDocData with an object-shaped updater
  // (prev => ({ ...prev, client_unknown: "1" })), but pdfData here is an
  // array (pdfData[0] is the current document). This adapts that updater
  // onto pdfData's actual shape so pdfData[0]?.client_unknown flips to "1"
  // immediately — that's what disables the Client Unknown button and is
  // what the Client Name column would read from without a full refetch.
  const setPdfDataFromConfirmToast = (updater) => {
    setPdfData((prev) => {
      const list = Array.isArray(prev) ? prev : [];
      const current = list[0] || {};
      const updatedFirst =
        typeof updater === "function" ? updater(current) : updater;
      return [updatedFirst, ...list.slice(1)];
    });
  };

  // The backend can return client_unknown as a numeric 1/0 or a "1"/"0"
  // string depending on the query path, so compare numerically instead of
  // with a brittle strict string check.
  const isPdfDocClientUnknown = Number(pdfData[0]?.client_unknown) === 1;

  // Processed/Unprocessed reflects the document's actual approval outcome,
  // not OCR completion or client-linkage: unprocessed until the linked
  // request is Approved or Rejected, using the same documentRequestStatus
  // state the existing Approve/Reject buttons and status icons already read
  // (set from existingDocumentRequestStatus / getDocumentRequestStatusFunc /
  // the approve+reject handlers) - no new status or API.
  const isDocumentProcessed = ["approved", "rejected"].includes(
    documentRequestStatus?.toLowerCase(),
  );
  const documentStatusLabel = isDocumentProcessed ? "Processed" : "Unprocessed";
  let formattedCreatedAt = null;
  if (documentCreatedAt) {
    try {
      // DB values are stored in UTC (same assumption ../../utils/formatDate
      // makes) - appending "Z" so the Date parses as UTC and date-fns then
      // formats it in the browser's local time, matching how dates are
      // shown everywhere else in the app.
      formattedCreatedAt = formatDateFns(
        new Date(documentCreatedAt.replace(" ", "T") + "Z"),
        "d MMM yyyy, hh:mm a",
      );
    } catch (e) {
      formattedCreatedAt = null;
    }
  }

  // useEffect(() => {
  //   const iframe = iframeRef.current;

  //   if (iframe) {
  //     const handleLoad = () => {
  //       setLoading(false);
  //     };

  //     const handleError = () => {
  //       setLoading(false);
  //       setError("Failed to load PDF");
  //     };

  //     // Add event listeners
  //     iframe.addEventListener("load", handleLoad);
  //     iframe.addEventListener("error", handleError);

  //     // Check if iframe is already loaded
  //     if (iframe.contentWindow) {
  //       try {
  //         const readyState = iframe.contentDocument?.readyState;
  //         if (readyState === "complete") {
  //           handleLoad();
  //         }
  //       } catch (e) {
  //       }
  //     }
  //     return () => {
  //       iframe.removeEventListener("load", handleLoad);
  //       iframe.removeEventListener("error", handleError);
  //     };
  //   }
  // }, [pdfSrc]);

  const getDocumentRequestStatusFunc = async () => {
    const response = await getDocumentRequestStatus(token, requestId);
    const data = await response.data;
    setDocumentRequestStatus(data[0]?.document_status);
  };

  const pdfBlob = async () => {
    setLoading(true);
    setPdfDataLoading(true);
    try {
      const response = await pdfBase64Data(token, documentID, document_table);
      const data = response.data;
      setPdfBase64(data);
    } catch (error) {
      console.error("Error fetching PDF Blob:", error);
    } finally {
      setLoading(false);
      setPdfDataLoading(false);
    }
  };

  const pdfDetailsData = async () => {
    setLoading(true);
    setPdfDataLoading(true);
    try {
      const response = await pdfDetails(token, documentID, document_table);
      const data = response?.data;

      if (response.code === 200) {
        setPdfData(data);
        setPdfSrc(data[0]?.pdflink);
      } else {
        showError("Error while getting document");
      }
    } catch (error) {
      console.error("Error fetching PDF details:", error);
    } finally {
      setLoading(false);
      setPdfDataLoading(false);
    }
  };

  const pdfDetailsVersionData = async () => {
    setLoading(true);
    try {
      const response = await pdfDetails(
        token,
        documentID,
        document_table,
        documentVersionId,
      );
      const data = response.data;
      setPdfData(data);
      setPdfSrc(data[0]?.pdflink);
    } catch (error) {
      console.error("Error fetching PDF version details:", error);
    } finally {
      setLoading(false);
    }
  };

  const getDocumentDetails = async () => {
    if (!setDocumentDetails) return;
    const url = `${baseUrl}/api/get-all-doc-data?document_id=${documentID}&isAdmin=${is_admin}&userId=${user_id}`;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) throw new Error("Failed to fetch document details");

      const data = await response.json();

      if (isMounted.current) {
        setDocumentDetails(data?.data[0]?.document[0]);
        if (setUpdatedFromPDF) {
          setUpdatedFromPDF(true);
        }
        if (refetchDocumentTable) {
          refetchDocumentTable();
        }
      }
    } catch (error) {
      console.error("Error fetching document details:", error);
    }
  };

  useEffect(() => {
    if (requestId != documentRequestID) {
      getDocumentRequestStatusFunc();
    }
  }, [requestId]);

  useEffect(() => {
    if (linkRequest) {
      getDocumentDetails();
    }
  }, [linkRequest, documentRequestStatus]);

  useEffect(() => {
    setValue("addClientName", clientID);
    setValue("name", documentTitle);
    setValue("subcategory", documentSubCategory);
    fetchSubCategory();
    if (clientID && clientID !== "null") {
      getClientNameDetails();
      // getClientRefNumber();
      // fetchRequestList(benefId);
    }
  }, []);

  useEffect(() => {
    const status = existingDocumentRequestStatus
      ? existingDocumentRequestStatus.toLowerCase()
      : "";
    if (clientID && clientID !== "null" && status !== "approved") {
      fetchRequestList(benefId);
    }
  }, [existingDocumentRequestStatus]);

  // ✅ ADD THIS NEW EFFECT
  // When documentRequestStatus changes (after approval), refresh the document details in parent
  useEffect(() => {
    if (
      documentRequestStatus &&
      documentRequestStatus.toLowerCase() === "approved"
    ) {
      // Call getDocumentDetails to update the parent state with fresh data
      getDocumentDetails();
    }
  }, [documentRequestStatus]);

  useEffect(() => {
    if (!clientNameLabel) {
      setValue("addClientName", null);
      setValue("caseId", "");
    }
    if (
      clientNameLabel === defaultClientNameLabel &&
      clientNameLabel &&
      !getValues("addClientName")
    ) {
      setValue("addClientName", clientID);
      if (clientID && clientID !== "null") {
        getClientRefNumber();
      }
    }
  }, [clientNameLabel]);

  // useEffect(() => {
  //   if (clientID && clientID !== "null") {
  //     getClientNameDetails();
  //   }
  // }, [editor]);

  useEffect(() => {
    if (assignClient === true) {
      fetchRequestList(benefId);
    }
  }, [assignClient]);

  useEffect(() => {
    pdfDetailsData();
    pdfBlob();
  }, []);

  useEffect(() => {
    setIsClientListFetched(false);
    if (clientNames.length > 0) {
      setSearchedClientId(
        clientNames.map((client) => {
          if (
            client._module === "Contacts" ||
            client._module === "cpm_CaseParties"
          ) {
            return client.case_id; // Use case_id for Contacts
          }
          return client.id; // Use id for other modules
        }),
      );
      setIsClientListFetched(true);
    }
  }, [clientNames]);

  useEffect(() => {
    (clientID || contactId) &&
    !requestId &&
    !linkRequest &&
    // requestOptions?.length > 0 &&
    !documentRequestStatus
      ? setShowLinkButton(true)
      : setShowLinkButton(false);
  }, [requestOptions, documentRequestStatus]);

  const handleChange = (index) => {
    setTabValue(index);
  };

  const handleApproveDocument = (e) => {
    setApproveConfirmOpen(true);
  };

  const handleDisapproveDocument = (e) => {
    setDisapproveConfirmOpen(true);
  };

  const changePdfDetailsContainerVisibility = () => {
    setIsPdfDetailsContainerOpen(!isPdfDetailsContainerOpen);
  };

  // DMS-local client reference number lookup - uses getCaseStatus instead of a
  // separate get-client-reference-number call.
  const getClientRefNumber = async () => {
    try {
      const response = await fetch(
        `${baseUrl}/api/getCaseStatus?caseId=${clientID}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = await response.json();
      setValue("caseId", data?.caseDetails?.[0]?.caseid_c || "");
    } catch (error) {
      // best-effort pre-population - leave caseId untouched on failure
    }
  };

  const getClientNameDetails = async () => {
    // benID is not passed by every caller (e.g. the client documents list),
    // so treat undefined like null/"" and fall back to clientID - otherwise
    // the lookup ran with contact_id=undefined and both top fields stayed empty.
    const contactId = benID ? benID : clientID;
    const clientNameResponse = await getClientName({
      contact_id: contactId,
      token: token,
    });
    setClientNameLabel(clientNameResponse?.data?.name);
    setDefaultClientNameLabel(clientNameResponse?.data?.name);
  };

  const fetchSubCategory = async () => {
    try {
      const response = await getAllFieldTypeList({
        token,
        type: "document_subtype",
      });
      setSubCategoryOption(response.data);
    } catch (error) {
      return error;
    }
  };

  // DMS-local client reference number lookup - uses getCaseStatus (already fetched for
  // the search list) instead of a separate get-client-reference-number call. A genuine
  // request failure still surfaces the error toast; a client simply having no reference
  // number set is not treated as an error.
  const handleClientNameChange = async (contactId) => {
    let response;
    let data;
    try {
      response = await fetch(`${baseUrl}/api/getCaseStatus?caseId=${contactId}`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      data = await response.json();
    } catch (error) {
      response = null;
    }

    if (response?.ok && data?.caseDetails) {
      // setClientNameLabel("Client Name");
      setValue("caseId", data?.caseDetails?.[0]?.caseid_c || "");
      setContactId(contactId);
    } else {
      toast.error(
        "Error while getting client details in DMS. Please contact admin!",
        {
          position: "top-center",
          autoClose: 5000,
          theme: "dark",
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        },
      );
      setValue("caseId", "");
      setContactId("");
    }
  };
  const fetchRequestList = async (selectedClient) => {
    if (selectedClient) {
      setLinkRequest(false);
      //const url = `${baseUrl}/api/get-doc-request-data?isAdmin=${is_admin}&userId=${user_id}&contact_id=${selectedClient}&unlinked=True`;
      const url = `${baseUrl}/api/get-client-document-requests-for-linking?userId=1&isAdmin=1&contact_id=${selectedClient}`;
      try {
        const response = await fetch(url, {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        const data = await response.json();
        if (data?.code === 200) {
          // Create the additional item
          const additionalItem = {
            document_request_id: "Additional Document",
            document_req_name: "Additional Document",
          };

          // Add it as the first item to the data array
          const updatedData = [
            additionalItem,
            ...data?.data?.document_requests_for_linking,
          ];

          // Set the updated data to the state
          setRequestOptions(updatedData);
        } else {
          // Set only the additional document in the state
          setRequestOptions([
            {
              document_request_id: "Additional Document",
              document_req_name: "Additional Document",
            },
          ]);
        }
      } catch (error) {
        return error;
      }
    }
  };

  const handleLinkRequest = (e) => {
    setLinkRequestOpen(true);
  };

  const onEditDocumentFormSubmit = async (editDocumentFormData) => {
    setSubmitLoading(true);

    const ocrData = {};
    const otherFormData = {};

    Object.keys(editDocumentFormData).forEach((key) => {
      if (key.startsWith("ocr_")) {
        if (editDocumentFormData[key]) {
          const originalKey = key.replace("ocr_", "");
          ocrData[originalKey] = editDocumentFormData[key];
        }
      } else {
        otherFormData[key] = editDocumentFormData[key];
      }
    });

    if (Object.keys(ocrData).length > 0) {
      const ocrDataString = JSON.stringify(ocrData);
      try {
        const ocrEndpoint = existingOcrData
          ? `${baseUrl}/api/update-ocr-data
`
          : `${baseUrl}/api/add-ocr-data`;
        const bodyData = {
          document_id: documentID,
          ocr_data: ocrDataString,
        };

        const res = await fetch(ocrEndpoint, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(bodyData),
        });
        res.status === 200 && setExistingOcr(true);
      } catch (error) {
        console.error("Error posting OCR data:", error);
      }
    }

    const selectedClient = clientNames.find(
      (c) => c.id === otherFormData.addClientName,
    );

    const contactIdToSend = selectedClient?.case_id || selectedClient?.id;

    const editDocumentData = {
      token: token,
      user_id: user_id,
      document_id: documentID,
      document_desc: description,
      document_name: otherFormData.name,
      document_sub_category: otherFormData.subcategory,
      contact_id: otherFormData.addClientName,
    };

    // If a client name label is provided, set it as the default label
    // and mark the client as known by updating the "client_unknown" flag to "0".
    if (clientNameLabel) {
      setDefaultClientNameLabel(clientNameLabel);
      editDocumentData.client_unknown = "0";
    }

    const editDocumentFormResponse = await editDocument(editDocumentData);

    if (editDocumentFormResponse.code === 200) {
      getDocumentDetails();
      setAssignClient(true);
      setSubmitLoading(false);
      showSuccess("Document is updated successfully");
    } else {
      setSubmitLoading(false);
      showError("Error while updating document");
    }
  };

  const clientIdsString = searchedClientId.join(",");

  // Fetches and updates client data (case status and legal team) for the provided client IDs.
  const fetchAdditionalClientData = async () => {
    setAdditionalDataLoading(true);
    if (!isClientListFetched) {
      console.error("No client IDs found to fetch data.");
      setAdditionalDataLoading(false);
      return;
    }

    try {
      const fetchedData = [];

      const response = await fetch(
        `${baseUrl}/api/getCaseStatus?caseId=${clientIdsString}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = await response.json();
      if (data?.caseDetails) {
        data.caseDetails.forEach((caseDetail) => {
          const { status, Lead_Attorney, Legal_Assistant, Paralegal } =
            caseDetail;

          fetchedData.push({
            status,
            Lead_Attorney,
            Legal_Assistant,
            Paralegal,
          });
        });
      }

      setClientNames((prev) =>
        prev.map((client, index) => ({
          ...client,
          ...(fetchedData[index] || {}),
        })),
      );

      setAdditionalDataLoading(false);
      setAdditionalDataFetched(true);
    } catch (error) {
      setAdditionalDataLoading(false);
      console.error("Error fetching additional client data:", error);
    }
  };

  // Fetches and updates the client list based on the search term and offset.
  const getClientList = useCallback(
    async (searchTerm, offsetValue, contactId) => {
      if (offsetValue === 0) {
        setClientNames([]);
      }
      if (searchTerm) {
        setClientNameLabel("Client Name");
        setSearchLoading(true);
        try {
          const url = `${baseUrl}/api/customGlobalSearch?q=${searchTerm}&max_num=20&offset=${offsetValue}&highlights=true`;

          const response = await fetch(url, {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          const data = await response.json();

          if (data?.total > 0) {
            setClientNames((prev) => [...prev, ...data.records]);
            setTotal(data.total);
            setSearchLoading(false);
            setShowMoreLoading(false);
          } else {
            if (data?.error == "Failed to Search") {
              setSugarTokenIssue(
                "Invalid token for accessing the SugarCRM APIs.",
              );
            } else {
              setSearchClientNotFound(true);
            }
            setSearchLoading(false);
          }
        } catch (error) {
          setSearchLoading(false);
          console.error("Error:", error);
        }
      } else {
        if (!contactId) {
          setClientNameLabel("");
        }
      }
    },
    [],
  );

  const cleanValue = (value) => {
    if (!value || typeof value !== "string") return value;

    // Remove ONLY prefixes like "1. ", "4. ", "12. "
    return value.replace(/^\s*\d+\.\s*/, "").trim();
  };

  // Wraps the existing completion handler only to advance the OCR popup's
  // steps; handleOcrComplete itself is unchanged.
  const handleOcrCompleteWithProgress = async (ocrData) => {
    ocrCompletedRef.current = true;
    setOcrPerformed(true);
    setOcrPhase("analyzing");
    try {
      await handleOcrComplete(ocrData);
    } finally {
      setOcrPhase("done");
      clearTimeout(ocrCloseTimerRef.current);
      ocrCloseTimerRef.current = setTimeout(() => {
        setOcrPhase(null);
        setOcrDialogOpen(false);
      }, 1600);
    }
  };

  // Request in flight -> "Extracting Text". If it ends without results
  // (error / nothing to OCR), close the popup, as the old toast showed no error.
  useEffect(() => {
    if (loadingOcr) {
      setOcrPhase((phase) => (phase ? "extracting" : phase));
    } else {
      setOcrPhase((phase) =>
        phase === "extracting" && !ocrCompletedRef.current ? null : phase
      );
    }
  }, [loadingOcr]);

  // OCR cancelled before the request started (e.g. no OCR keys configured).
  useEffect(() => {
    if (!performOcr && !loadingOcr) {
      setOcrPhase((phase) => (phase === "reading" ? null : phase));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [performOcr]);

  useEffect(() => () => clearTimeout(ocrCloseTimerRef.current), []);

  // inside PdfViewer
  const handleOcrComplete = async (ocrData) => {
    // console.log("[ClientSearch][OCR] data", ocrData);

    // Show the newly-extracted fields: select the OCR Fields tab and briefly
    // highlight it. Never force the user back to a different tab afterwards -
    // the highlight alone fades; the tab stays on OCR Fields (or wherever the
    // user manually navigates to in the meantime).
    setActiveDetailsTab("ocr");
    setOcrJustCompleted(true);
    setTimeout(() => setOcrJustCompleted(false), 6000);

    // Validate alien number before searching
    const invalidValues = [
      "not found",
      "null",
      "undefined",
      "-",
      "na",
      "n/a",
      "",
    ];
    // Extract possible alien number from ANY OCR field
    let detectedAlien = null;

    Object.values(ocrData).forEach((val) => {
      if (!val || typeof val !== "string") return;

      const cleaned = val.replace(/\s/g, "");

      // Match A-XXXXXXXX or 7-9 digit number
      const match = cleaned.match(/A?-?\d{7,9}/i);
      if (match && !detectedAlien) {
        detectedAlien = match[0];
      }
    });

    const alienNumber = detectedAlien;

    const phoneNumber = ocrData?.phone_number?.trim?.();

    // Validate both alien and phone numbers before searching
    const validAlien =
      alienNumber && !invalidValues.includes(alienNumber.toLowerCase());
    const validPhone =
      phoneNumber && !invalidValues.includes(phoneNumber.toLowerCase());

    let searchTerm = null;
    if (validAlien) {
      let cleanAlienNumber = alienNumber.replace(/\D/g, "");
      searchTerm = cleanValue(cleanAlienNumber);
      setCurrentAlienNumber(searchTerm);
    } else if (validPhone) {
      // Normalize phone (remove spaces, dashes, etc.)
      let searchPhoneNumber = phoneNumber.replace(/[^\d+]/g, "").trim();
      searchTerm = cleanValue(searchPhoneNumber);
      setCurrentPhoneNumber(searchTerm);
    }

    if (!searchTerm) {
      console.warn(
        "[ClientSearch][OCR] No valid alien number or phone number found.",
      );
      return;
    }

    const url = `${baseUrl}/api/customGlobalSearch?q=${searchTerm}&max_num=20&offset=0&highlights=true`;

    try {
      const res = await fetch(url, {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();

      if (!data?.records?.length) {
        // console.warn("[ClientSearch][OCR] No records found for", alienNumber);
        return;
      }
      const records = data?.records ?? [];

      const matched =
        records.find(
          (r) =>
            r.alien_number_c === searchTerm ||
            r.im_alien_number_c === searchTerm,
        ) ||
        records.find(
          (r) =>
            r.telephone_number_c === searchTerm ||
            r.phone_mobile === searchTerm,
        );

      if (!matched) {
        console.warn("[ClientSearch][OCR] No records found");
        return;
      }

      const selectedId = matched.case_id || matched.id;
      // Ensure the option exists
      setClientNames((prev) => {
        const exists = prev.some((c) => c.id === matched.id);

        return exists ? prev : [matched, ...prev];
      });

      // Store this selection until clientNames update triggers the useEffect
      setPendingSelectedId(selectedId);
    } catch (error) {
      console.error("[ClientSearch][OCR] Error performing search:", error);
    }
  };

  useEffect(() => {
    // When clientNames update and we have a pending selectedId, apply it.
    if (pendingSelectedId && clientNames.length > 0) {
      const match = clientNames.find(
        (c) => c.id === pendingSelectedId || c.case_id === pendingSelectedId,
      );

      if (match) {
        setValue("addClientName", match.id, {
          shouldValidate: true,
          shouldDirty: true,
        });
        setClientNameLabel(match.name);
        setClientInputValue(match.name);
        const contactIdToUse = match.case_id || match.id;
        handleClientNameChange(contactIdToUse);
        setBenefId(match.id);
        setPendingSelectedId(null); // reset
      }
    }
  }, [clientNames, pendingSelectedId]);

  const [searchTerm, handleClientNameSearch] = useDebounceSearch(
    "",
    documentID,
    offset,
    clientID,
    2000,
    getClientList,
  );

  useEffect(() => {
    setOffset(0);
    setTotal(0);
  }, [searchedTerm]);

  // Fetches additional client data when the client list is fetched or client IDs change.
  useEffect(() => {
    if (isClientListFetched || clientIdsString) {
      fetchAdditionalClientData();
    }
  }, [isClientListFetched, clientIdsString]);

  const handlePerformOcr = () => {
    // Show the OCR Processing popup (replaces the old disclaimer toast).
    clearTimeout(ocrCloseTimerRef.current);
    ocrCompletedRef.current = false;
    setOcrPhase("reading");
    setOcrDialogOpen(true);
    setPerformOcr((prev) => !prev);
    setOcrTrigger((prev) => prev + 1);
    setShowFields(true);
  };

  // Checks if a given source URL is an image based on its file extension.
  const isImage = (src) => {
    const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "svg"];
    const extension = src.split(".").pop().toLowerCase();
    return imageExtensions.includes(extension);
  };

  // Downloads the document by creating a temporary link element.
  const handleDocumentDownload = function () {
    const link = document.createElement("a");
    link.href = pdfSrc;
    link.target = "_blank";
    link.download = documentTitle || "download";
    link.click();
  };

  // Converts a base64 string to a Blob object with the specified MIME type.
  const base64ToBlob = (base64, mimeType = "application/zip") => {
    const binaryString = atob(base64); // Decode the base64 string
    const length = binaryString.length;
    const bytes = new Uint8Array(length);
    for (let i = 0; i < length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return new Blob([bytes], { type: mimeType });
  };

  // Converts the PDF's Base64 data to a Blob and updates the zip content when pdfBase64 changes.
  useEffect(() => {
    if (pdfBase64 && pdfBase64[0]?.data) {
      const blob = base64ToBlob(pdfBase64[0]?.data);
      setZipContent(blob);
    }
  }, [pdfBase64]);

  //Setting the clientId for the Info Card
  const clientInfoID = function () {
    const addClientNameValue = getValues("addClientName");
    if (
      addClientNameValue !== null &&
      addClientNameValue !== undefined &&
      addClientNameValue !== ""
    ) {
      setBusinessCardInfoClientID(addClientNameValue);
    } else if (clientNameLabel === defaultClientNameLabel) {
      setBusinessCardInfoClientID(clientID);
    } else {
      setBusinessCardInfoClientID(clientID);
    }
  };

  useEffect(() => {
    clientInfoID();
  }, [clientID, getValues("addClientName"), clientNameLabel]);

  const selectedClientInfo = clientNames?.find(
    (client) =>
      client.id === businessCardInfoClientID ||
      client.case_id === businessCardInfoClientID,
  );

  const initialClientInfo = {
    name: clientNameLabel || selectedClientInfo?.name || "",
    caseid_c: getValues("caseId") || selectedClientInfo?.caseid_c || "",
    phone_mobile: selectedClientInfo?.phone_mobile || "",
    email: selectedClientInfo?.email?.[0]?.email_address || "",
  };

  return (
    <>
      {isBlocking && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            zIndex: 1300, // Higher than most MUI components
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.4)",
            pointerEvents: "all",
          }}
        ></div>
      )}
      <ConfirmToast
        open={confirmUnknownDialogOpen}
        onClose={() => setConfirmUnknownDialogOpen(false)}
        onConfirm={confirmMarkClientUnknown}
        title="Mark Client as Unknown"
        message="Are you sure you want to mark the client as unknown?"
        documentId={documentID}
        setIsClientUnknown={setIsClientUnknown}
        setDocData={setPdfDataFromConfirmToast}
        setDocumentUpdatedToTrue={refetchDocumentTable}
      />
      {approveConfirmOpen && (
        <ApprovePDFDocumentPopup
          documentId={documentID}
          documentRequestId={requestId}
          setReqStatus={setDocumentRequestStatus}
          setApproveConfirmOpen={setApproveConfirmOpen}
          {...(fromTable !== "Documents" && {
            currentTabId: currentTabId,
            closeTabById: closeTabById,
          })}
          refetchDocumentTable={refetchDocumentTable}
        />
      )}

      {disapproveConfirmOpen && (
        <RejectPDFDocumentPopup
          documentRequestId={requestId}
          setReqStatus={setDocumentRequestStatus}
          setDisapproveConfirmOpen={setDisapproveConfirmOpen}
          currentTabId={currentTabId}
          closeTabById={closeTabById}
        />
      )}

      {linkRequestOpen && (
        <LinkToRequest
          documentId={documentID}
          requestOptions={requestOptions}
          setLinkRequest={setLinkRequest}
          setReqStatus={setDocumentRequestStatus}
          setRequestId={setRequestId}
          setLinkRequestOpen={setLinkRequestOpen}
          setSelectedRequestLabel={setSelectedRequestLabel}
          setIsBlocking={setIsBlocking}
          currentTabId={currentTabId}
          closeTabById={closeTabById}
          pdfLink={pdfSrc}
          documentRequestId={requestId}
        />
      )}

      {
        <div className="pdf-viewer-container relative pb-">
          {!editor ? (
            <div className="pdf-viewer">
              {/* The informational left side (badge/title/status/date) always
                  renders, even when showPdfOnly is true (Recycle Bin) - only
                  the action icons on the right (Approve/Reject/Link/Edit/OCR/
                  Client Unknown/BusinessCardInfo) stay hidden there, since
                  none of those actions make sense on a soft-deleted
                  document. */}
              <div className="pdf-viewer-header gap-2">
                  <div className="pdf-viewer-header-info flex items-center gap-3 flex-1 min-w-0">
                    <div style={{ fontSize: 20 }}>
                      <DocumentTypeBadge type={documentType} />
                    </div>
                    <div className="min-w-0">
                      <div className="pdf-document-title capitalize truncate">
                        {documentTitle}
                        {selectedRequestLabel || linkedDocReqName
                          ? " - " + (selectedRequestLabel || linkedDocReqName) + " (Linked Request)"
                          : null}
                      </div>
                      <div className="pdf-viewer-header-meta flex items-center flex-wrap gap-3">
                        <span
                          className="pdf-status-badge pdf-status-badge--ok"
                        >
                          <IoCheckmarkCircle />
                          {documentStatusLabel}
                        </span>
                        {formattedCreatedAt && (
                          <span className="pdf-viewer-header-meta-item">
                            <IoTimeOutline />
                            Added on {formattedCreatedAt}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  {!showPdfOnly && (
                  <div className="view-pdf-doc-icon items-center">
                    {(clientID || assignClient) && (
                      <BusinessCardInfo clientID={businessCardInfoClientID} />
                    )}
                    {canMarkClientUnknown && (
                      <ViewerActionButton
                        tone="client"
                        icon={PersonOutlinedIcon}
                        title="Client Unknown"
                        disabledReason="Client Unknown is not available for this document"
                        disabled={
                          isPdfDocClientUnknown ||
                          isClientUnknown ||
                          defaultClientNameLabel ||
                          loading
                            ? true
                            : false
                        }
                        onClick={openClientUnknownDialog}
                      />
                    )}
                    {canPerformOCR && (isImage(pdfSrc) || documentType?.toLowerCase() === "pdf") && (
                      <ViewerActionButton
                        tone={existingOcrData || ocrPerformed ? "ocrDone" : "ocr"}
                        icon={OcrScanIcon}
                        title={
                          loadingOcr
                            ? "Performing OCR..."
                            : existingOcrData || ocrPerformed
                              ? "Re-OCR"
                              : "Perform OCR"
                        }
                        disabledReason={
                          !documentSubCategory
                            ? "Select a document sub category to perform OCR"
                            : "Document is still loading"
                        }
                        loading={loadingOcr}
                        disabled={!isDocumentRendered || !documentSubCategory}
                        onClick={handlePerformOcr}
                      />
                    )}
                    {/* Add Task / Send SMS disabled (SugarCRM-dependent) - commented out,
                        not deleted, so they can be re-enabled for projects that need
                        SugarCRM integration.
                    {clientID && canAddTask && (
                      <AddTask contactId={contactId} />
                    )}
                    {clientID && clientPhone && canSendSMS ? (
                      <SendSMS clientPhone={clientPhone} clientID={clientID} />
                    ) : null}
                    */}
                    {documentType === "pdf" &&
                      ((clientID || contactId) || canPerformOCR) &&
                      document_table != "contract_requests" &&
                      (document_table != "document_request_settings" || !document_table) &&
                      (canLinkDocument || canRelinkDocument) && (
                        <>
                          {/* Shown next to OCR whenever OCR is available for a PDF (its
                              own action, separate from OCR). Enabled only when a client
                              is linked (separation links pages to that client's
                              requests) and OCR has completed (existingOcrData is set
                              when OCR data exists / OCR finished successfully). */}
                          <ViewerActionButton
                            tone="separate"
                            icon={CallSplitOutlinedIcon}
                            title="Separate Documents"
                            disabledReason={
                              pdfDataLoading
                                ? "Loading PDF, please wait..."
                                : !(clientID || contactId)
                                  ? "Link this document to a client to separate it"
                                  : loadingOcr
                                    ? "OCR is running, please wait..."
                                    : "Perform OCR on this document first to separate it"
                            }
                            disabled={pdfDataLoading || !(clientID || contactId) || loadingOcr || !existingOcrData}
                            onClick={() => setShowSeparation(true)}
                          />
                          <DocumentSeparationDialog
                            open={showSeparation}
                            onClose={() => setShowSeparation(false)}
                            documentID={documentID}
                            onSaved={(result) => {
                              // Original fully separated -> it is in the trash, close it;
                              // otherwise reload it (it now has only the remaining pages).
                              if (result?.master?.status === "fully_separated") {
                                if (closeTabById || changeActiveTab) (closeTabById || changeActiveTab)();
                              } else {
                                pdfBlob();
                                pdfDetailsData();
                              }
                            }}
                          />
                        </>
                      )}
                    {document_table != "contract_requests" &&
                      (document_table != "document_request_settings" ||
                        !document_table) && (
                        <>
                          {(canLinkDocument || canRelinkDocument) && (
                            <ViewerActionButton
                              tone="link"
                              icon={LinkIcon}
                              title="Link Request"
                              disabledReason="Linking is not available for this document"
                              onClick={handleLinkRequest}
                              disabled={
                                !(
                                  (canLinkDocument && showLinkButton) ||
                                  (canRelinkDocument &&
                                    documentRequestStatus &&
                                    documentRequestStatus.toLowerCase() !==
                                      "approved")
                                )
                              }
                            />
                          )}

                          {(clientID || contactId) &&
                            requestId &&
                            documentRequestStatus?.toLowerCase() ===
                              "approved" && (
                              <ViewerActionButton
                                readOnly
                                tone="approvedStatus"
                                icon={CheckCircleOutlineIcon}
                                title="Approved"
                              />
                            )}
                          {(clientID || contactId) &&
                            requestId &&
                            documentRequestStatus?.toLowerCase() ===
                              "rejected" && (
                              <ViewerActionButton
                                readOnly
                                tone="rejectedStatus"
                                icon={HighlightOffIcon}
                                title="Rejected"
                              />
                            )}

                          {canApproveDocument && (
                            <ViewerActionButton
                              tone="approve"
                              icon={CheckIcon}
                              title="Approve"
                              onClick={handleApproveDocument}
                              disabled={
                                documentRequestStatus?.toLowerCase() !==
                                "uploaded"
                              }
                              disabledReason="Only uploaded documents can be approved"
                            />
                          )}

                          {canApproveDocument && (
                            <ViewerActionButton
                              tone="reject"
                              icon={CloseIcon}
                              title="Reject"
                              onClick={handleDisapproveDocument}
                              disabled={
                                documentRequestStatus?.toLowerCase() !==
                                "uploaded"
                              }
                              disabledReason="Only uploaded documents can be rejected"
                            />
                          )}
                        </>
                      )}

                    {documentType === "pdf" &&
                    document_table != "contract_requests" &&
                    (document_table != "document_request_settings" ||
                      !document_table)
                      ? canEditPdf && (
                          <ViewerActionButton
                            tone="edit"
                            icon={EditOutlinedIcon}
                            title="Edit PDF"
                            disabledReason="Loading PDF, please wait..."
                            disabled={pdfDataLoading}
                            onClick={() => setEditor(!editor)}
                          />
                        )
                      : null}
                    <ViewerActionButton
                      tone="details"
                      icon={isPdfDetailsContainerOpen ? CloseIcon : ArticleOutlinedIcon}
                      title={isPdfDetailsContainerOpen ? "Hide PDF Details" : "PDF Details"}
                      onClick={changePdfDetailsContainerVisibility}
                    />
                    {(closeTabById || changeActiveTab) && (
                      <ViewerActionButton
                        tone="close"
                        icon={CloseIcon}
                        title="Close Viewer"
                        onClick={() => (closeTabById || changeActiveTab)()}
                      />
                    )}
                  </div>
                  )}
                </div>
              <div
                className={
                  document_table != "contract_requests" &&
                  document_table != "document_request_settings"
                    ? showPdfOnly
                      ? "w-full"
                      : "document-viewer-with-from"
                    : null
                }
              >
                <div className="iframe-wrapper  relative w-full">
                  {loading && (
                    <div className="absolute inset-0 flex justify-center items-center bg-white bg-opacity-80 z-10">
                      <Loading />
                    </div>
                  )}
                  {!loading && pdfData && pdfSrc ? (
                    documentType.toLowerCase() === "pdf" ||
                    documentType.toLowerCase() === "txt" ? (
                      <iframe
                        ref={iframeRef}
                        title={documentTitle}
                        src={pdfSrc}
                        width="100%"
                        height="590"
                        key={pdfSrc}
                        onLoad={() => {
                          setLoading(false);
                          setIsDocumentRendered(true);
                        }}
                      ></iframe>
                    ) : ["doc", "docx", "xls", "xlsx", "pptx", "ppt"].includes(
                        documentType.toLowerCase(),
                      ) ? (
                      <div className="relative w-full h-full">
                        {/* <iframe
                          title={documentTitle}
                          src={`https://docs.google.com/viewer?url=${pdfSrc}&embedded=true`}
                          className="w-full h-full border-none"
                        ></iframe> */}
                        <iframe
                          title={documentTitle}
                          src={`https://view.officeapps.live.com/op/embed.aspx?src=${pdfSrc}`}
                          className="w-full h-full border-none"
                        ></iframe>

                        {/* <button
                          onClick={handleDocumentDownload}
                          className="absolute top-3 right-4 bg-[#44a0cf] hover:bg-[#3c8cb4] py-2 px-4 rounded-lg flex gap-1 justify-center items-center self-center transition-all duration-300 text-white"
                        >
                          <FaDownload />
                          Download
                        </button> */}
                      </div>
                    ) : documentType.toLowerCase() === "mp4" ? (
                      <div className="flex justify-center items-center w-full max-w-[800px]">
                        <video
                          controls
                          className="w-full h-auto max-h-[90vh] object-contain rounded-lg"
                        >
                          <source src={pdfData[0]?.pdflink} type="video/mp4" />
                        </video>
                      </div>
                    ) : documentType.toLowerCase() === "zip" && pdfSrc ? (
                      <ZipViewer
                        zipContent={zipContent}
                        zipSrc={pdfSrc}
                        base64ToBlob={base64ToBlob}
                      />
                    ) : isImage(pdfSrc) ? (
                      <div
                        style={{
                          width: "100%",
                          maxHeight: "590px", // limit visible area
                          overflow: "auto", // scroll if image is taller
                        }}
                      >
                        <img
                          src={pdfData[0]?.pdflink}
                          width="100%"
                          height="590"
                          alt={documentTitle}
                          onLoad={() => setIsDocumentRendered(true)}
                          onError={() => setIsDocumentRendered(true)}
                        />
                      </div>
                    ) : (
                      <div className="bg-[#ddeef6] border-l-4 border-[#44a0cf] text-white p-6 rounded-lg shadow-md max-w-md mx-auto flex flex-col justify-center items-center">
                        <span className="text-gray-800 text-base font-semibold mb-3 text-center">
                          This file is not supported for viewing here. You can
                          download it using the button below
                        </span>

                        <button
                          onClick={handleDocumentDownload}
                          className="bg-[#2b93c8d0] hover:bg-[#44a0cf] py-2 px-4 rounded-lg flex gap-1 justify-center items-center self-center transition-all duration-300"
                        >
                          <FaDownload />
                          Download
                        </button>
                      </div>
                    )
                  ) : null}
                </div>
                {document_table != "contract_requests" &&
                  document_table != "document_request_settings" &&
                  ///////////////////////////// Show only if `showPdfOnly` is false. /////////////////////////////
                  (showPdfOnly ? null : (
                    <div className="document-viewer-form">
                      <div className="field_wrapper client-lookup-field">
                        <div className="field">
                          <Controller
                            control={control}
                            name="addClientName"
                            render={({
                              field: { onChange, value, ...field },
                            }) => (
                              <Autocomplete
                                className="clientNameAuto"
                                name="addClientName"
                                noOptionsText={
                                  !searchClientNotFound
                                    ? sugarTokenIssue
                                      ? sugarTokenIssue
                                      : "Please enter the client name / alien number / case id / phone no / email"
                                    : "No clients found"
                                }
                                options={[
                                  ...clientNames,
                                  ...(total > offset + 20 || showMoreLoading
                                    ? [{ name: "Show More", id: "show_more" }]
                                    : []),
                                ]}
                                loading={searchLoading}
                                // getOptionLabel={(option) => option.name}
                                getOptionLabel={(option) => {
                                  // Check if option is an object and has a valid 'name' property
                                  if (
                                    typeof option === "object" &&
                                    option !== null &&
                                    typeof option.name === "string"
                                  ) {
                                    if (option.id === "show_more")
                                      return option.name;
                                    return option.name || "";
                                  }

                                  // Return a fallback value (could be an empty string or some placeholder text)
                                  return "";
                                }}
                                clearOnBlur={false}
                                disabled={
                                  (clientID &&
                                  clientID !== "null" &&
                                  !showLinkButton
                                    ? true
                                    : false) || !canEditClient
                                }
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label={
                                      !clientNameLabel
                                        ? "Client Name / Alien Number / Case Id / Phone No / Email"
                                        : clientNameLabel
                                    }
                                    InputProps={{
                                      ...params.InputProps,
                                    }}
                                    onChange={(event) => {
                                      const searchTerm = event.target.value;
                                      if (!searchTerm) {
                                        setClientNameLabel(
                                          defaultClientNameLabel
                                            ? defaultClientNameLabel
                                            : "Client Name / Alien Number / Case Id / Phone No / Email",
                                        );
                                      }

                                      handleClientNameSearch(searchTerm);
                                      // Store selectedClientName in component state or prop
                                      setSearchedTerm(searchTerm);
                                    }}
                                    onBlur={() => {
                                      if (!contactId) {
                                        setClientNameLabel(
                                          defaultClientNameLabel
                                            ? defaultClientNameLabel
                                            : "Client Name / Alien Number / Case Id / Phone No / Email",
                                        );
                                      }
                                    }}
                                    disabled={
                                      (clientID &&
                                        clientID !== "null" &&
                                        !showLinkButton) ||
                                      !canEditClient
                                    }
                                  />
                                )}
                                filterOptions={(options, state) => options}
                                renderOption={(props, option) => {
                                  if (option.id === "show_more") {
                                    return (
                                      <li
                                        {...props}
                                        onClick={async () => {
                                          setShowMoreLoading(true); // Set loading to true
                                          setOffset((prev) => prev + 20);
                                        }}
                                        style={{
                                          cursor: "pointer",
                                          color: showMoreLoading
                                            ? "grey"
                                            : "#1a6b7c",
                                        }}
                                      >
                                        {showMoreLoading
                                          ? "Loading..."
                                          : option.name}
                                      </li>
                                    );
                                  }
                                  return (
                                    <li
                                      {...props}
                                      key={option.id}
                                      className={` p-3 border-b border-b-gray-300 hover:bg-gray-200 ${
                                        additionalDataLoading
                                          ? "pointer-events-none opacity-25"
                                          : ""
                                      }`}
                                    >
                                      <p>{option.name}</p>
                                      <div className="grid grid-cols-2 gap-1">
                                        {/* SugarCRM-specific fields (Alien Number, Case Status,
                                            Lead Attorney, Active Legal Assistant, Active Paralegal)
                                            removed - DMS standalone now only shows local client
                                            fields below.
                                        {additionalDataFetched &&
                                          !searchLoading &&
                                          !additionalDataLoading && (
                                            <>
                                              <span className="font-semibold">
                                                Alien Number
                                              </span>
                                              <span className="break-words">
                                                : {option.im_alien_number_c}
                                              </span>
                                              <span className="font-semibold">
                                                Case Status
                                              </span>
                                              <span className="break-words ">
                                                : {option?.status}
                                              </span>

                                              <span className="font-semibold">
                                                Lead Attorney
                                              </span>
                                              <span className="break-words ">
                                                : {option?.Lead_Attorney}
                                              </span>

                                              <span className="font-semibold">
                                                Active Legal Assistant
                                              </span>
                                              <span className="break-words ">
                                                : {option?.Legal_Assistant}
                                              </span>

                                              <span className="font-semibold">
                                                Active Paralegal
                                              </span>
                                              <span className="break-words ">
                                                : {option?.Paralegal}
                                              </span>
                                            </>
                                          )}
                                        */}
                                        <span className="font-semibold">
                                          Client Reference Number
                                        </span>
                                        <span className="break-words ">
                                          : {option?.caseid_c}
                                        </span>

                                        <span className="font-semibold">
                                          Phone
                                        </span>
                                        <span className="break-words ">
                                          : {option?.phone_mobile}
                                        </span>

                                        <span className="font-semibold">
                                          Email
                                        </span>
                                        <span className="break-words">
                                          :{" "}
                                          {option?.email?.[0]?.email_address ||
                                            ""}
                                        </span>
                                      </div>

                                      {(searchLoading ||
                                        additionalDataLoading) && (
                                        <div className="absolute inset-0 bg-gray-50 opacity-10 flex justify-center items-center">
                                          <span className="text-gray-500 font-semibold">
                                            <Loading />
                                          </span>
                                        </div>
                                      )}
                                    </li>
                                  );
                                }}
                                {...field}
                                value={
                                  clientNames
                                    ? clientNames.find((client) =>
                                        client._module === "Contacts"
                                          ? client.case_id === field.value
                                          : client.id === field.value,
                                      ) || null
                                    : null
                                }
                                inputValue={clientInputValue}
                                onInputChange={(
                                  event,
                                  newInputValue,
                                  reason,
                                ) => {
                                  if (reason === "input") {
                                    setClientInputValue(newInputValue);
                                  }
                                }}
                                onChange={(event, newValue) => {
                                  if (!newValue) {
                                    onChange(null);
                                    setValue("caseId", "");
                                    setContactId("");
                                    return;
                                  }

                                  if (newValue.id === "show_more") return;

                                  const selectedClient = newValue;

                                  setClientNameLabel(selectedClient.name);
                                  setClientInputValue(selectedClient.name);

                                  //  ONLY THIS LOGIC
                                  const contactIdToUse =
                                    selectedClient.case_id || selectedClient.id;

                                  //  SINGLE API CALL
                                  handleClientNameChange(contactIdToUse);

                                  //  keep form value
                                  onChange(selectedClient.id); // ALWAYS store actual selected record

                                  setContactId(contactIdToUse);
                                  setBenefId(selectedClient.id);

                                  if (pendingSelectedId)
                                    onChange(pendingSelectedId);
                                }}
                                classes={{ paper: "autocomplete-paper" }}
                              />
                            )}
                          />
                          <span className="error-message">
                            {errors["addClientName"]?.message}
                          </span>
                        </div>
                      </div>

                      <div className="field_wrapper client-lookup-field">
                        <div className="field">
                          <Controller
                            name="caseId"
                            control={control}
                            render={({ field: { onChange, value } }) => (
                              <InputUI
                                name="caseId"
                                label="Client Reference Number"
                                disabled
                                type="text"
                                value={value ? value : ""}
                                setValue={onChange}
                                variant="outlined"
                                register={register}
                                cssStyles={{
                                  width: "100%",
                                }}
                              />
                            )}
                          />
                        </div>
                      </div>

                      <Tabs
                        value={activeDetailsTab}
                        onValueChange={setActiveDetailsTab}
                        className="w-full mt-2"
                      >
                        <TabsList>
                          <TabsTrigger value="details">
                            Document Details
                          </TabsTrigger>
                          <TabsTrigger value="client">
                            Client Information
                          </TabsTrigger>
                          <TabsTrigger value="ocr">OCR Fields</TabsTrigger>
                        </TabsList>
                        <TabsContent value="details">

                      <div className="field_wrapper">
                        <div className="field">
                          <Controller
                            name="name"
                            control={control}
                            render={({ field: { onChange, value } }) => (
                              <InputUI
                                name="name"
                                label="Document Name"
                                type="text"
                                value={value ? value : ""}
                                setValue={onChange}
                                variant="outlined"
                                register={register}
                                // disabled={true}
                                cssStyles={{
                                  margin: "20px 0px",
                                  width: "100%",
                                }}
                              />
                            )}
                          />
                          <span className="error-message">
                            {errors["name"]?.message}
                          </span>
                        </div>
                      </div>
                      <div className="field_wrapper">
                        <div className="field">
                          <Controller
                            name="category"
                            control={control}
                            render={({ field: { onChange, value } }) => (
                              <InputUI
                                name="category"
                                label="Category"
                                disabled
                                type="text"
                                value={documentCategory ? documentCategory : ""}
                                variant="outlined"
                                register={register}
                                cssStyles={{
                                  width: "100%",
                                }}
                              />
                            )}
                          />
                        </div>
                      </div>
                      <div
                        className="field_wrapper"
                        style={{ marginTop: "15px", marginBottom: "5px" }}
                      >
                        <FormControl className="" fullWidth>
                          <Controller
                            control={control}
                            name="subcategory"
                            render={({ field: { onChange, value } }) => (
                              <Autocomplete
                                options={subCategoryOption}
                                filterOptions={filterOptions}
                                getOptionLabel={(option) =>
                                  option.fields_name || ""
                                }
                                onChange={(e, value) => {
                                  onChange(value ? value.field_setting_id : "");
                                }}
                                value={
                                  subCategoryOption?.find(
                                    (option) =>
                                      option.field_setting_id === value,
                                  ) || null
                                }
                                sx={{ margin: "10px 0px" }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label="Sub Category"
                                    variant="outlined"
                                  />
                                )}
                              />
                            )}
                          />
                        </FormControl>
                        {/* <FormControl fullWidth>
                          <InputLabel id="select-label">
                            Sub Category
                          </InputLabel>
                          <Controller
                            control={control}
                            name="subcategory"
                            // defaultValue={category}
                            render={({ field: { onChange, value } }) => (
                              <SelectBox
                                name="subcategory"
                                labelId="select-label"
                                variant="outlined"
                                id="simple-select"
                                value={value || ""}
                                onChange={onChange}
                                label="Sub Category"
                                {...register("subcategory")}
                              >
                                {subCategoryOption?.map((category) => (
                                  <MenuItem
                                    key={category.field_setting_id}
                                    value={category.field_setting_id}
                                  >
                                    {category.fields_name}
                                  </MenuItem>
                                ))}
                              </SelectBox>
                            )}
                          />
                        </FormControl> */}
                        <span className="error-message">
                          {errors["subcategory"]?.message}
                        </span>
                      </div>
                      <div className="field_wrapper">
                        <div className="field">
                          <TextField
                            name="description"
                            label="Description"
                            multiline
                            minRows={3}
                            maxRows={3}
                            value={
                              description && description !== null
                                ? description
                                : ""
                            }
                            onChange={(e) => setDescription(e.target.value)}
                            variant="outlined"
                            style={{ marginTop: "15px", marginBottom: "15px" }}
                            fullWidth
                          />
                        </div>
                      </div>

                        </TabsContent>
                        <TabsContent value="client">
                          <ClientInfoPanel
                            clientID={businessCardInfoClientID}
                            initialClientData={initialClientInfo}
                          />
                        </TabsContent>
                        <TabsContent value="ocr">
                      <OcrFields
                        highlight={ocrJustCompleted}
                        control={control}
                        errors={errors}
                        setValue={setValue}
                        subCategory={documentSubCategory}
                        documentID={documentID}
                        showFields={showFields}
                        setShowFields={setShowFields}
                        performOcr={performOcr}
                      />
                        </TabsContent>
                      </Tabs>

                      <ButtonUI
                        loading={submitLoading}
                        variant="contained"
                        buttonText="Submit"
                        handleSubmit={handleSubmit}
                        onFormSubmit={onEditDocumentFormSubmit}
                        style={{ backgroundColor: "#1a6b7c", color: "#fff" }}
                        sx={{ "&:hover": { backgroundColor: "#155e6e" } }}
                      />
                      <OcrProcessingDialog
                        open={ocrDialogOpen && !!ocrPhase}
                        phase={ocrPhase}
                        onClose={() => setOcrDialogOpen(false)}
                      />
                      {showPopup && (
                        <ChatPopup
                          document_url={pdfBase64?.[0]?.pdflink}
                          documentType={documentType}
                          documentData={pdfBase64?.[0]?.data}
                          onClose={() => setShowPopup(false)}
                          subCategory={documentSubCategory}
                          documentID={documentID}
                          ocrStatus={performOcr}
                          setPerformOcr={setPerformOcr}
                          setLoadingOcr={setLoadingOcr}
                          setExistingOcr={setExistingOcr}
                          setValue={setValue}
                          setShowFields={setShowFields}
                          onOcrComplete={handleOcrCompleteWithProgress}
                          ocrTrigger={ocrTrigger}
                        />
                      )}
                    </div>
                  ))}
              </div>
              <div
                className={
                  isPdfDetailsContainerOpen
                    ? "pdf-details-container"
                    : "hide-pdf-details-container"
                }
              >
                <div className="pdf-details-header">
                  <div className="pdf-details-header-icon">
                    <IoDocumentText />
                  </div>
                  <div className="pdf-details-header-title">
                    Document Details
                  </div>
                  <div
                    className="close-pdf-details-container-icon"
                    onClick={changePdfDetailsContainerVisibility}
                  >
                    <RiCloseCircleFill />
                  </div>
                </div>
                <div className="pdf-details-content">
                  <PdfDetails
                    pdfData={pdfData}
                    documentID={documentID}
                    documentTitle={documentTitle}
                    documentType={documentType}
                    pdfDetailsVersionData={pdfDetailsVersionData}
                    documentVersionId={documentVersionId}
                    setDocumentVersionId={setDocumentVersionId}
                    // document_version={document_version}
                  />
                </div>
              </div>
            </div>
          ) : !pdfDataLoading ? (
            <div className="show-pdf-editor">
              <div
                onClick={() => setEditor(!editor)}
                className="go-back-to-pdf-viewer"
                title="Back"
              >
                <IoArrowBackCircleSharp />
              </div>
              <div>
                {editor && (
                  <PdfEditor
                    pdfBase64={pdfBase64}
                    documentID={documentID}
                    documentTitle={documentTitle}
                    documentURL={documentURL}
                    setEditor={setEditor}
                    pdfDetailsData={pdfDetailsData}
                    pdfBlob={pdfBlob}
                  />
                )}
              </div>
            </div>
          ) : (
            <Loading />
          )}
        </div>
      }
    </>
  );
};

export default PdfViewer;
